import { VStack } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import useIsNewRoute from '../../features/offers/hooks/useIsNewRoute';

interface Props {
  interval?: string;
}

const SingleOfferPrice: React.FC<React.PropsWithChildren<Props>> = ({
  interval,
  children,
  ...otherProps
}) => {
  const { t } = useTranslation();
  const isNewRoute = useIsNewRoute();

  return (
    <VStack
      spacing="2"
      m="auto"
      mt={{ base: '2', laptop: '8' }}
      w="100%"
      align={{ base: 'center', laptop: 'stretch' }}
      px="4"
      {...otherProps}
      data-test-id="ADVISORY-CONVO_OFFERS_SINGLE-OFFER_PRICE"
    >
      {interval && (
        <Interval>
          {interval}{' '}
          {isNewRoute &&
            `- ${t('SALES-CONVERSATION_OFFERS_PRICE_INCLUSIVE-TAX')}`}
        </Interval>
      )}
      <Price>{children}</Price>
    </VStack>
  );
};

const Price = styled.p`
  color: ${({ theme }) => theme.typo.title};
  font-weight: 700;
  font-size: 3.2rem;
  line-height: 120%;
`;

const Interval = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.labels.guaranteeText};
`;

export default SingleOfferPrice;
